import React from "react"

import {connect} from "@irati/store"
import {ReduxState} from "@irati/store/types"
import {FormattedMessage} from "@irati/utils/lang"
import CurrentPositionMarker from "@irati-web/geolocation/src/components/GeoMap/CurrentPositionMarker"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"
import {OverlayPlacement} from "@irati/ui/src/Tooltip/Overlay"

import {StyledTooltip, StyledOverlay, StyledBr} from "./styled/LocationAccuracyInfo"

interface Props {
  isMobile: boolean
}

const LocationAccuracyInfo: React.FC<Props> = ({isMobile}) => (
  <Flex alignItems="center">
    <CurrentPositionMarker />
    <Body small margin={[0, 1, 0]}>
      <FormattedMessage id="perks.searchByLocation.locationAccuracyInfo.header" />
    </Body>
    <StyledTooltip placement={isMobile ? OverlayPlacement.Bottom : OverlayPlacement.Top} OverlayComponent={StyledOverlay}>
      <Body small>
        <FormattedMessage
          id="perks.searchByLocation.locationAccuracyInfo.tooltip.text"
          values={{
            boldHeader: (
              <Body small weight="bold" color="ink" marginBottom={1}>
                <FormattedMessage id="perks.searchByLocation.locationAccuracyInfo.tooltip.boldHeader" />
              </Body>
            ),
            br: <StyledBr />
          }} />
      </Body>
    </StyledTooltip>
  </Flex>
)

const mapStateToProps = ({mq}: ReduxState) => ({isMobile: mq.lessThan.md})

export default React.memo(
  connect(
    mapStateToProps,
    null
  )(LocationAccuracyInfo)
)
